import { Stack, Typography } from '@mui/material';
import React from 'react';

import { FormToggleLabelContainer } from '@/shared/components/ui/form/components/form-toggle/form-toggle.styled';
import { StyledSwitch } from '@/shared/components/ui/form/components/toggle/toggle.styled';
import {
  TToggleLabelColor,
  TToggleLabelPosition,
  TToggleProps,
} from '@/shared/components/ui/form/components/toggle/toggle.types';

export const Toggle: React.FC<TToggleProps> = ({
  leftLabel,
  rightLabel,
  disabled = false,
  checked = false,
  ...props
}) => {
  const getLabelColor = (position: TToggleLabelPosition): TToggleLabelColor => {
    if (disabled) {
      return 'textDisabled';
    }

    if (position === 'left') {
      return checked ? 'textSecondary' : 'primary';
    }

    return checked ? 'primary' : 'textSecondary';
  };

  const renderLabel = (label: string, position: TToggleLabelPosition) => {
    return (
      <FormToggleLabelContainer $position={position}>
        <Typography variant="p7" color={getLabelColor(position)}>
          {label}
        </Typography>
      </FormToggleLabelContainer>
    );
  };

  return (
    <Stack direction="row" alignItems="center">
      {leftLabel && renderLabel(leftLabel, 'left')}
      <StyledSwitch checked={checked} disabled={disabled} {...props} />
      {rightLabel && renderLabel(rightLabel, 'right')}
    </Stack>
  );
};
